import initI18n from './i18n';
import { seedQuizAnalysisSchemas } from './shared/seedQuizAnalysisSchemas';

export default function init() {
  initI18n();
  seedQuizAnalysisSchemas();
}
